export default "__VITE_ASSET__e8588c55__"